export function randomRGB(percentOffset: number = 0) {
  let min = 0;
  let max = 255;
  // `percentOffset` is an offset from the start/end of the possible color values. For example, if set to `20` then the bottom and top 20% of the color space will not be selected. This is useful for making sure that there is enough difference between any possible white/black values.o
  if (percentOffset) {
    min = Math.ceil((max - min) / percentOffset);
    max = Math.floor(max - min);
  }
  return `rgb(${getRandomInt(0, 255)}, ${getRandomInt(0, 255)}, ${getRandomInt(0, 255)})`;
}

export function getRandomInt(min: number, max: number) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
}

export function getRandomDOMId(namespace = 'dom-id') {
  const uid =
    Date.now().toString(36) +
    Math.floor(Math.pow(10, 12) + Math.random() * 9 * Math.pow(10, 12)).toString(36);
  return `${namespace}-${uid}`;
}
